@if (ratingObj[1] && edit) {
  <i class="fa fa-star click" (click)="changeRating(1)"></i>
}
@if (!ratingObj[1] && edit) {
  <i class="fa fa-star-o click" (click)="changeRating(1)"></i>
}

@if (ratingObj[2] && edit) {
  <i class="fa fa-star click" (click)="changeRating(2)"></i>
}
@if (!ratingObj[2] && edit) {
  <i class="fa fa-star-o click" (click)="changeRating(2)"></i>
}

@if (ratingObj[3] && edit) {
  <i class="fa fa-star click" (click)="changeRating(3)"></i>
}
@if (!ratingObj[3] && edit) {
  <i class="fa fa-star-o click" (click)="changeRating(3)"></i>
}

@if (ratingObj[4] && edit) {
  <i class="fa fa-star click" (click)="changeRating(4)"></i>
}
@if (!ratingObj[4] && edit) {
  <i class="fa fa-star-o click" (click)="changeRating(4)"></i>
}

@if (ratingObj[5] && edit) {
  <i class="fa fa-star click" (click)="changeRating(5)"></i>
}
@if (!ratingObj[5] && edit) {
  <i class="fa fa-star-o click" (click)="changeRating(5)"></i>
}

<!-- Read Only -->
@if (ratingObj[1] && !edit) {
  <i class="fa fa-star"></i>
}
@if (!ratingObj[1] && !edit) {
  <i class="fa fa-star-o"></i>
}

@if (ratingObj[2] && !edit) {
  <i class="fa fa-star"></i>
}
@if (!ratingObj[2] && !edit) {
  <i class="fa fa-star-o"></i>
}

@if (ratingObj[3] && !edit) {
  <i class="fa fa-star"></i>
}
@if (!ratingObj[3] && !edit) {
  <i class="fa fa-star-o"></i>
}

@if (ratingObj[4] && !edit) {
  <i class="fa fa-star"></i>
}
@if (!ratingObj[4] && !edit) {
  <i class="fa fa-star-o"></i>
}

@if (ratingObj[5] && !edit) {
  <i class="fa fa-star"></i>
}
@if (!ratingObj[5] && !edit) {
  <i class="fa fa-star-o"></i>
}
